<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_5"></a>CONTENTS</h2>
<p class="imagec"><img alt="Illustration" src="images/common.jpg"/></p>
<p class="toc"><a href="#/xhtml/chapter01">Across the Millenia</a></p>
<p class="toc"><span href="#/xhtml/chapter02" title="Link target outside of Sample">Hand and Mind</span></p>
<p class="toc"><span href="#/xhtml/chapter03" title="Link target outside of Sample">Mounts and Meanings</span></p>
<p class="toc"><span href="#/xhtml/chapter04" title="Link target outside of Sample">Fingers and Thumbs</span></p>
<p class="toc"><span href="#/xhtml/chapter05" title="Link target outside of Sample">Thumbs Up</span></p>
<p class="toc"><span href="#/xhtml/chapter06" title="Link target outside of Sample">Main Lines</span></p>
<p class="toc"><span href="#/xhtml/chapter07" title="Link target outside of Sample">Branch Lines</span></p>
<p class="toc"><span href="#/xhtml/chapter08" title="Link target outside of Sample">Warning Signs</span></p>
<p class="toc"><span href="#/xhtml/chapter09" title="Link target outside of Sample">Hands at Work</span></p>
<p class="toc"><span href="#/xhtml/chapter10" title="Link target outside of Sample">Special Marks</span></p>
<p class="toc"><span href="#/xhtml/chapter11" title="Link target outside of Sample">Hand in Hand</span></p>
<p class="toc"><span href="#/xhtml/chapter12" title="Link target outside of Sample">All Fingers and Thumbs</span></p>
<p class="toc"><span href="#/xhtml/chapter13" title="Link target outside of Sample">Along the Same Lines</span></p>
<p class="toc"><span href="#/xhtml/chapter14" title="Link target outside of Sample">Hands Across the Ages</span></p>
<p class="toc"><span href="#/xhtml/chapter15" title="Link target outside of Sample">Health in The Hand</span></p>
<p class="toca"><span href="#/xhtml/bm01" title="Link target outside of Sample">ACKNOWLEDGEMENTS</span></p>
<div class="pagebreak">
<p class="imagea"><a id="page_6"></a><img alt="Illustration" src="images/f0006-01.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?84bda922